import React, {useState, useEffect} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {TRUE} from "../../../constants/general-constants";
import {FALSE} from "../../../constants/general-constants";
import {useHistory} from 'react-router-dom';
import {functions} from "../../../constants/common-functions";
import HomeBox from "../components/HomeBox";
import HomeBoxRAG from "../components/HomeBoxRAG";
import {COLOR_SOCIAL} from "../../../constants/general-constants";
import {OMNISCAN_BLUE} from "../../../constants/colors";
import {OMNISCAN_BLUE_RGB} from "../../../constants/colors";

export default function HomeBoxProjects({homeConfig, isMobile}){
	
	const [isLive, setIsLive] = useState(false);
	const history = useHistory();
	const [total, setTotal] = useState(0);
		const [red, setRed] = useState(0);
		const [amber, setAmber] = useState(0);
		const [green, setGreen] = useState(0);
	
	useEffect(() => {
		if(homeConfig){
			setIsLive(homeConfig.isLiveLinkProjects);
			setTotal(homeConfig.projectsTotal);
			setRed(homeConfig.projectsRed);
			setAmber(homeConfig.projectsAmber);
			setGreen(homeConfig.projectsGreen);
		}
	}, [homeConfig]);
	
	const clickFunction = () => {
		
	};
	
	
	return (
		<HomeBox
			isMobile={isMobile}
			isLive={isLive}
			title="Projects"
			color={OMNISCAN_BLUE}
			colorRgb={OMNISCAN_BLUE_RGB}
			clickFunction={clickFunction}
			icon="tools"
			isLast={TRUE}
			delay={1200}
		>
			<HomeBoxRAG
				title="Projects"
				total={total}
				red={red}
				amber={amber}
				green={green}
			/>
		</HomeBox>
	);
}